import React from 'react';

const ContactInfo = ({ title, contactDetails }) => {
    const renderValue = (detail) => {
        const value = detail.value;
        const label = detail.label.toLowerCase();

        // Handle arrays (like hours)
        if (Array.isArray(value)) {
            return value.map((line, index) => (
                <p key={index} className="text-text-light">{line}</p>
            ));
        }

        // Make phone clickable
        if (label === 'phone') {
            const phoneClean = value.replace(/[^0-9]/g, '');
            return (
                <a 
                    href={`tel:${phoneClean}`} 
                    className="text-text-light hover:text-primary-blue transition-colors font-semibold"
                >
                    {value}
                </a>
            );
        }

        // Make email clickable
        if (label === 'email') {
            return (
                <a 
                    href={`mailto:${value}`} 
                    className="text-text-light hover:text-primary-blue transition-colors"
                >
                    {value}
                </a>
            );
        }

        // Default text
        return <p className="text-text-light">{value}</p>;
    };

    return (
        <div className="glass-panel p-8 h-fit animate-fade-in-up opacity-0">
            <h3 className="text-2xl font-bold mb-6">{title}</h3>
            <div className="space-y-6">
                {contactDetails.map((detail) => (
                    <div key={detail.id}>
                        <p className="font-bold text-primary-blue mb-1">{detail.label}</p>
                        {renderValue(detail)}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ContactInfo;
